import React, { Component, } from "react"
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import SnackbarAlert from '../../common/SnackbarAlert';
import TablePagination from '@mui/material/TablePagination';
import axios from 'axios';
import FormGroup from '@mui/material/FormGroup';
import PageSkeletonPayouts from '../../common/skeletons/PageSkeletonPayouts';
import { TbCurrencyDollarOff } from "react-icons/tb";
import { AiOutlineSafety } from "react-icons/ai";
import {
    Button,
    Switch,
    Typography,
    Box,
    FormControlLabel,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    FormControl,
    Select,
    MenuItem,
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import get_and_post_data_skeleton from '../../common/common/get_and_post_data_skeleton';
import getGeoInfo from '../../common/common/getGeoInfo';
import CreatePriceStr from '../../common/common/CreatePriceStr';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import NewFeatureComingSoon from '../../Influencer/Dashboard/NewFeatureComingSoon';
// import InstantPayoutsImage from '../../../media/site_media/dashboard/waystoearn/instant-payouts.webp'
import InstantPayoutsImage from '../../../media/site_media/dashboard/waystoearn/instant-payouts.webp'
import PayoutModal from "./PayoutModal";
import Loader from "../../common/Loader";
import { PiSmileySad } from "react-icons/pi";
import { withRouter } from "../../common/common/withRouter";

const paths = require('../../../paths.json');


const modalStyle = {
    display: 'flex',
    height: 'auto',
    // bgcolor: 'rgba(0,0,0,1)',
    minHeight: '100vh',
    minWidth: '100vw',
    overflowY: 'hidden',
    outline: 'none',
    zIndex: '9999',
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#fff',
        color: '#222222',
        fontSize: '16px',
        fontWeight: '600',
        paddingTop: '20px',
        borderRadius: '8px',
        paddingBottom: '20px',
        borderBottom: 'none',
        textAlign: 'center',
        justifyContent: 'center',
    },
    [`&.${tableCellClasses.body}`]: {
        backgroundColor: 'var(--rebranding-content-background-color)',
        fontSize: '14px',
        color: '#2222222',
        borderBottom: 'none',
        shading: 'none',
        fontWeight: '600',
        textAlign: 'center',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 'none',
    },
}));

const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 42,
    height: 24,
    marginLeft: 5,
    padding: 0,
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 24,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(17px)',
            color: '#fff !important',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: 'var(--brand-color)',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 20,
        height: 20,
        borderRadius: 40,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 100,
        opacity: 1,
        backgroundColor:
            theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
        boxSizing: 'border-box',
    },
}));


const smallHeading = {
    fontWeight: '500',
    fontSize: '14px',
    color: '#000',
    margin: '0px 0px 5px 0px',
    fontFamily: 'Roboto'
}

const smallDescription = {
    color: '#6E89AF',
    fontSize: '14px',
    fontWeight: '500',
    margin: '5px auto 0px 0px',
    display: 'block',
}

const largeNumber = {
    color: '#000',
    fontSize: '32px',
    fontWeight: '600',
    margin: '0px auto 0px 0px',
    display: 'block',
}

const smallDescriptionInfo = {
    color: '#000',
    fontSize: '14px',
    fontWeight: '500',
    margin: '10px auto 0px 0px',
    display: 'block',
}

// TBC Pagination for tables
// This needs to be converted to setState logic
// const [page, setPage] = React.useState(2);
// const [rowsPerPage, setRowsPerPage] = React.useState(10);
// const handleChangePage = (event, newPage) => {
//     setPage(newPage);
// };
//
// const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
// };


class Income extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // billing
            influencer_transfers: [],
            page_influencer_transfers: [],
            influencer_login_link: "",
            error: "",
            page_num: 0,
            n_rows_per_page: 5,
            last_month_string: '',
            pay_date_string: '',
            last_month_income: 0,
            upload_loading: true,
            currency: 'GBP',
            initial_loaded: true,
            payout_frequency: 'Daily',
            next_date: '',
            available_balance: 0,
            available_balance_currency: 'gbp',
            pending_balance: 0,
            pending_balance_currency: 'gbp',
            withdraw_amount: 0,
            withdraw_amount_str: '0.00',
            start_symbol: '£',
            end_symbol: '',
            payout_error: '',
            process_loading: false,
            payoutModal: false,
            snackbarOpen: false,
            snackbarSeverity: 'error',
            snackbarColor: 'var(--danger-color)',
            oldAccount: false,
            // instantPayoutModal: false,
        };
        this.get_settings_billing_page_django_data = this.get_settings_billing_page_django_data.bind(this);
        this.PostDataLoad = this.PostDataLoad.bind(this);
        this.OpenStripeUserProfile = this.OpenStripeUserProfile.bind(this)
        this.UpdatePageData = this.UpdatePageData.bind(this);
        this.UpdateRowsPerPageData = this.UpdateRowsPerPageData.bind(this);
        this.getGeoInfo = this.getGeoInfo.bind(this);
        this.processPayout = this.processPayout.bind(this);
        this.handlePayoutModalClose = this.handlePayoutModalClose.bind(this);
        this.initialPayoutLoad = this.initialPayoutLoad.bind(this);
    }


    handlePayoutModalOpen = () => {
        this.setState({ payoutModal: true })
    }

    handlePayoutModalClose = () => {
        this.setState({ payoutModal: false })
    }


    handlePayoutAmountUpdate = (event) => {
        this.setState({
            withdraw_amount: event.target.value
        })
    }

    initialPayoutLoad() {
        const form_data = new FormData();
        let currency = this.getGeoInfo(true)
        form_data.append('currency', currency)
        const { incomeData } = this.props
        if (!Object.keys(incomeData).length) {
            this.get_settings_billing_page_django_data(
                paths.BACKEND_URL + "api/settings_page_income_page_info",
                'post',
                false,
                form_data,
                this.PostDataLoad,
            )
        } else {
            this.PostDataLoad(null, incomeData)
        }
    }

    processPayout() {
        // if 0
        this.setState(
            {
                process_loading: true,
            }
        )
        if (this.state.withdraw_amount === 0) {
            this.setState(
                {
                    payout_error: 'Must enter an amount to withdraw!',
                    snackbarOpen: true,
                    snackbarSeverity: 'error',
                    snackbarColor: 'var(--danger-color)',
                    upload_loading: false,
                    process_loading: false,
                }
            )
        } else if (this.state.withdraw_amount > this.state.available_balance) {
            this.setState(
                {
                    payout_error: 'Can not withdraw more than available!',
                    snackbarOpen: true,
                    snackbarSeverity: 'error',
                    snackbarColor: 'var(--danger-color)',
                    upload_loading: false,
                    process_loading: false,
                }
            )
        } else {
            // check that the amount is above the available balance
            const form_data = new FormData()
            form_data.append('amount', this.state.withdraw_amount)
            axios({
                method: 'post',
                url: paths.BACKEND_URL + "api/settings/process_payout",
                data: form_data,
                headers: {
                    'Content-type': 'application/json',
                },
                withCredentials: true,
            })
                .then((res) => {
                    if (!res.data.error) {
                        this.setState(
                            {
                                available_balance: res.data.available_balance,
                                available_balance_currency: res.data.available_balance_currency,
                                influencer_transfers: res.data.influencer_transfers,
                                page_influencer_transfers: res.data.page_influencer_transfers,
                                snackbarOpen: true,
                                payout_error: 'Payout initiated',
                                snackbarSeverity: 'info',
                                snackbarColor: 'var(--brand-color)',
                            }
                        )
                        this.handlePayoutModalClose();
                        this.setState({
                            initial_loaded: true,
                            upload_loading: true,
                            process_loading: false,
                        })
                    } else {
                        if (res.data.error === 'more than available') {
                            this.setState(
                                {
                                    payout_error: 'Can not withdraw more than available!',
                                    snackbarOpen: true,
                                    snackbarSeverity: 'error',
                                    snackbarColor: 'var(--danger-color)',
                                    upload_loading: false,
                                    process_loading: false,
                                }
                            )
                        } else {
                            this.setState(
                                {
                                    payout_error: 'Error, please try again.',
                                    snackbarOpen: true,
                                    snackbarSeverity: 'error',
                                    snackbarColor: 'var(--danger-color)',
                                    upload_loading: false,
                                    process_loading: false,
                                }
                            )
                        }
                    }
                })
        }
    }

    componentDidMount() {
        this.UpdatePageData(0)
        this.initialPayoutLoad()
    }
    OpenStripeUserProfile() {
        this.get_settings_billing_page_django_data(
            paths.BACKEND_URL + "checkout/stripe_user_page/",
            'get',
            false,
            {},
            null,
            true,
        )
    }


    // closeInstantPayoutModal = () => {
    //     this.setState({instantPayoutModal: false})
    // }

    UpdatePageData(page_num) {
        this.setState({ page_num: page_num })
        this.setState({
            page_influencer_transfers: this.state.influencer_transfers.slice(
                this.state.n_rows_per_page * page_num,
                (this.state.n_rows_per_page * page_num) + this.state.n_rows_per_page
            )
        })
    }
    UpdateRowsPerPageData(n_rows_per_page) {
        this.setState({ page_num: 0 })
        this.setState({ n_rows_per_page: n_rows_per_page })
        this.setState({ page_influencer_transfers: this.state.influencer_transfers.slice(0, n_rows_per_page) });
    }
    PostDataLoad(response, state) {
        let res = {}
        if (response) {
            res = response
            this.props.setState({ incomeData: response.data })
        } else if (state) {
            res = {data: state}
        }
        var keys = Object.keys(res.data)
        var dict = {}
        for (let i = 0; i < keys.length; i++) {
            dict[keys[i]] = eval("res.data." + keys[i])
        }
        this.setState(dict)
        this.setState({ upload_loading: false })
        if (res.data.available_balance_currency === 'GBP') {
            this.setState({
                start_symbol: '£',
                end_symbol: '',
            })
        } else if (res.data.available_balance_currency === 'USD') {
            this.setState({
                start_symbol: '$',
                end_symbol: '',
            })
        } else if (res.data.available_balance_currency === 'EUR') {
            this.setState({
                start_symbol: '€',
                end_symbol: '',
            })
        } else if (res.data.available_balance_currency === 'AUD') {
            this.setState({
                start_symbol: 'AU$',
                end_symbol: '',
            })
        } else if (res.data.available_balance_currency === 'CAD') {
            this.setState({
                start_symbol: 'CA$',
                end_symbol: '',
            })
        } else if (res.data.available_balance_currency === 'SEK') {
            this.setState({
                start_symbol: '',
                end_symbol: 'kr',
            })
        } else if (res.data.available_balance_currency === 'NZD') {
            this.setState({
                start_symbol: 'NZ$',
                end_symbol: '',
            })
        }
    }
    get_settings_billing_page_django_data = get_and_post_data_skeleton
    getGeoInfo = getGeoInfo
    render() {
        if ((this.state.upload_loading) && (this.state.initial_loaded)) {
            this.setState({ initial_loaded: false })
            const form_data = new FormData();
            let currency = this.getGeoInfo(true)
            form_data.append('currency', currency)
            const { incomeData } = this.props
            if (!Object.keys(incomeData).length) {
                this.get_settings_billing_page_django_data(
                    paths.BACKEND_URL + "api/settings_page_income_page_info",
                    'post',
                    false,
                    form_data,
                    this.PostDataLoad,
                )
            } else {
                this.PostDataLoad(null, incomeData)
            }
        }
        let button_text = ''
        if (this.state.error === 'account not completed') {
            button_text = 'Setup Account'
        } else {
            button_text = 'Edit Account Details'
        }
        // 1 = old account, 2 = new account
        let account_type = 'old-account'

        // if testsetup is true, then the account is not connected, if false it's connected and will show extra
        let testSetup = false
        // this.state.error === 'account not completed'


        return (
            <>
                {this.state.upload_loading ?
                    <>
                        <PageSkeletonPayouts />
                    </>
                    :

                    <div>
                        <Grid
                            Container
                            xs={12}
                        //    justifyContent="center"
                        >
                            <Loader
                                loading={this.state.upload_loading || this.state.process_loading}
                                label={this.state.upload_loading ? "Getting data..." : this.state.process_loading ? "Processing..." : undefined}
                            />

                            <Grid container sx={{ justifyContent: 'space-between' }}>
                                {
                                    this.state.error === 'account not completed' ?
                                        null
                                        :
                                        <>

                                            {
                                                this.state.oldAccount ?
                                                    // No Display
                                                    null
                                                    :
                                                    // New Display
                                                    <>

                                                        <Grid xs={12} md={5.9} lg={5.9} sx={{ height: 'auto', width: '100%', marginTop: '0px' }}>
                                                            <div style={{ backgroundColor: '#fff', width: '100%', margin: 'auto auto auto auto', height: '100%', borderRadius: '8px', border: '1px solid #E4EBF6' }}>
                                                                <div style={{ padding: '15px 15px' }}>
                                                                    <span style={smallHeading}>Available Balance</span>
                                                                    <span style={largeNumber}>{CreatePriceStr(this.state.available_balance, this.state.available_balance_currency, true)}</span>
                                                                    {/* <span style={largeNumber}>£2042.98</span> */}
                                                                </div>
                                                            </div>
                                                        </Grid>

                                                        <Grid xs={12} md={5.9} lg={5.9} sx={{ height: 'auto', width: '100%', marginTop: {xs: '20px', lg: '0px'} }}>
                                                            <div style={{ backgroundColor: '#fff', width: '100%', margin: 'auto auto auto auto', height: '100%', borderRadius: '8px', border: '1px solid #E4EBF6' }}>
                                                                <div style={{ padding: '15px 15px' }}>
                                                                    <span style={smallHeading}>Pending Balance</span>
                                                                    {/* <span style={largeNumber}>£142.98</span> */}
                                                                    <span style={largeNumber}>{CreatePriceStr(this.state.pending_balance, this.state.pending_balance_currency, true)}</span>
                                                                </div>
                                                            </div>
                                                        </Grid>

                                                    </>


                                            }




                                        </>
                                }


                                <Grid xs={12} md={12} lg={this.state.error === 'account not completed' || this.state.oldAccount ? 12 : 5.9} sx={{ height: 'auto', width: '100%', margin: this.state.error === 'account not completed' ? '0px' : '20px 0px 0px 0px', }}>
                                    <div style={{ backgroundColor: '#fff', width: '100%', margin: 'auto auto auto auto', height: '100%', borderRadius: '8px', border: '1px solid #E4EBF6' }}>
                                        <div style={{ padding: '15px 15px' }}>
                                            <span style={smallHeading} >
                                                {
                                                    this.state.error === 'account not completed' ?
                                                        'Account Not Connected' : 'Account Connected'
                                                }
                                            </span>
                                            <span style={smallDescription}>
                                                {
                                                    this.state.error === 'account not completed' ?
                                                        'Connect your account to enable instant payouts.' : 'Your account is successfully connected to stripe. Edit your account details to change your payment or billing information.'
                                                }
                                            </span>
                                            {
                                                this.state.error === 'account not completed' || this.state.oldAccount === false ?
                                                    null :
                                                    <div>
                                                        <span style={smallDescriptionInfo}>Next Payment of {CreatePriceStr(this.state.last_month_income, this.state.currency)} due on {this.state.pay_date_string} and covers all activity for {this.state.last_month_string}</span>
                                                        <span style={{
                                                            color: 'var(--light-theme-text-color)',
                                                            fontSize: '12px',
                                                            fontWeight: '300',
                                                            paddingBottom: '0px',
                                                            textAlign: 'center',
                                                            width: '100%',
                                                        }}>*We make the payment on the 12th with the majority of payments taking 3 days; however, some may take longer.</span>
                                                    </div>

                                            }

                                            <div style={{ margin: '20px 0px 0px 0px', display: 'flex' }}>

                                                <Button
                                                    disableRipple
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: 'var(--brand-color)',
                                                        fontSize: '14px',
                                                        textTransform: 'none',
                                                        boxShadow: 'none',
                                                        borderRadius: '8px',
                                                        fontWeight: '600',
                                                        ':hover': {
                                                            backgroundColor: 'var(--brand-color-hover)', // theme.palette.primary.main
                                                            color: 'white', boxShadow: 'none',
                                                        },
                                                    }}
                                                    type="submit" value="LOGIN"
                                                    onClick={() => {
                                                        setTimeout(() => {
                                                            window.open(this.state.influencer_login_link)
                                                        }, 800);
                                                    }}>
                                                    {button_text}
                                                </Button>


                                            </div>


                                        </div>
                                    </div>

                                </Grid>


                                {
                                    this.state.error === 'account not completed' ?
                                        null
                                        :
                                        <>
                                            {
                                                this.state.oldAccount ?
                                                    null
                                                    :
                                                    <Grid xs={12} md={12} lg={this.state.error === 'account not completed' ? 12 : 5.9} sx={{ height: 'auto', width: '100%', margin: this.state.error === 'account not completed' ? '0px' : '20px 0px 0px 0px', }}>
                                                        <div style={{ backgroundColor: '#fff', width: '100%', margin: 'auto auto auto auto', height: '100%', borderRadius: '8px', border: '1px solid #E4EBF6' }}>
                                                            <div style={{ padding: '15px 15px' }}>
                                                                <span style={smallHeading}>
                                                                    Payouts
                                                                </span>
                                                                <span style={smallDescription}>
                                                                    Update the payout frequency or withdraw instantly.
                                                                </span>

                                                                <div style={{ margin: '10px 0px 0px 0px', display: 'flex' }}>

                                                                    <FormControl fullWidth height='16px' style={{ width: 'auto' }}>

                                                                        <Select
                                                                            labelId="demo-simple-select-label"
                                                                            id="demo-simple-select"
                                                                            value={this.state.payout_frequency}
                                                                            onChange={
                                                                                (event) => {
                                                                                    this.setState(
                                                                                        {
                                                                                            process_loading: true,
                                                                                        }
                                                                                    )
                                                                                    const form_data = new FormData()
                                                                                    form_data.append('frequency', event.target.value)
                                                                                    axios({
                                                                                        method: 'post',
                                                                                        url: paths.BACKEND_URL + "api/settings/update_payout_frequency",
                                                                                        data: form_data,
                                                                                        headers: {
                                                                                            'Content-type': 'application/json',
                                                                                        },
                                                                                        withCredentials: true,
                                                                                    })
                                                                                        .then((res) => {
                                                                                            this.setState(
                                                                                                {
                                                                                                    payout_frequency: event.target.value,
                                                                                                    next_date: res.data.next_date,
                                                                                                }
                                                                                            )
                                                                                            this.setState(
                                                                                                {
                                                                                                    process_loading: false,
                                                                                                }
                                                                                            )
                                                                                        })
                                                                                }
                                                                            }
                                                                            style={{ minWidth: '120px', maxWidth: '120px', maxHeight: '38px', borderRadius: '8px', margin: '0px 10px 0px 0px', }}
                                                                        >
                                                                            <MenuItem value={'Daily'} sx={{ textAlign: 'left' }}>
                                                                                {'Daily'}
                                                                            </MenuItem>
                                                                            <MenuItem value={'Weekly'} sx={{ textAlign: 'left' }}>
                                                                                {'Weekly'}
                                                                            </MenuItem>
                                                                            <MenuItem value={'Monthly'} sx={{ textAlign: 'left' }}>
                                                                                {'Monthly'}
                                                                            </MenuItem>
                                                                            <MenuItem value={'Manual'} sx={{ textAlign: 'left' }}>
                                                                                {'Manual'}
                                                                            </MenuItem>
                                                                        </Select>
                                                                    </FormControl>
                                                                    {/* <span style={{ margin: 'auto', fontWeight: '600', fontSize: '12px', margin: 'auto 10px auto 0px', }}>OR</span> */}

                                                                    <Button
                                                                        disableRipple
                                                                        variant="contained"
                                                                        sx={{
                                                                            backgroundColor: 'var(--brand-color)',
                                                                            fontSize: '14px',
                                                                            textTransform: 'none',
                                                                            margin: 'auto 0px auto 0px',
                                                                            boxShadow: 'none',
                                                                            borderRadius: '8px',
                                                                            fontWeight: '600',
                                                                            minWidth: '130px',
                                                                            ':hover': {
                                                                                backgroundColor: 'var(--brand-color-hover)', // theme.palette.primary.main
                                                                                color: 'white', boxShadow: 'none',
                                                                            },
                                                                        }}
                                                                        type="submit" value="LOGIN"
                                                                        // onClick={() => {
                                                                        //     this.processPayout();
                                                                        // }}

                                                                        onClick={this.handlePayoutModalOpen}


                                                                    >
                                                                        Instant Payout
                                                                    </Button>


                                                                </div>

                                                                {
                                                                    this.state.payout_frequency !== 'Manual' && this.state.error !== 'account not completed' ?
                                                                        <div>
                                                                            <span style={smallDescriptionInfo}>Your next payout will be: {this.state.next_date}</span>
                                                                        </div>
                                                                        :
                                                                        null
                                                                }



                                                            </div>
                                                        </div>

                                                    </Grid>


                                            }

                                        </>


                                }











                                {
                                    this.state.error === 'account not completed' ?
                                        null :
                                        <Grid xs={12} md={12} lg={12}
                                            sx={{
                                                height: 'auto', width: '100%', margin: '20px auto 0px auto', border: '1px solid #E4EBF6', borderRadius: '8px',
                                                backgroundColor: '#fff'
                                            }}>

                                            <Box
                                                sx={{
                                                    display: { xs: 'none', 'md': 'flex' },
                                                }}
                                            >
                                                <Grid
                                                    container
                                                    spacing={0}
                                                    alignItems="center"
                                                    justifyContent="center">
                                                    <Grid xs={12} sm={12} md={12} lg={12}>

                                                        <TableContainer
                                                            sx={{ boxShadow: 'none', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}>
                                                            <Table sx={{ minWidth: 650, }} size="small" aria-label="a dense table">
                                                                <TableHead>
                                                                    <StyledTableRow sx={{ borderBottom: '1px #E4EBF6 solid' }}>
                                                                        <StyledTableCell align="right">Amount</StyledTableCell>
                                                                        <StyledTableCell align="right">Date</StyledTableCell>
                                                                        <StyledTableCell align="right">Description</StyledTableCell>
                                                                    </StyledTableRow>
                                                                </TableHead>
                                                                {this.state.influencer_transfers?.length ?
                                                                    <TableBody>
                                                                        {this.state.page_influencer_transfers.map((user_transaction, index) => {
                                                                            return (
                                                                                <StyledTableRow
                                                                                    key={'user_transaction_' + index}
                                                                                // sx={{ '&:last-child td, &:last-child th': { border: 1 } }}
                                                                                >
                                                                                    <StyledTableCell component="th" scope="row">
                                                                                        {user_transaction['value']}
                                                                                    </StyledTableCell>
                                                                                    <StyledTableCell align="right">{user_transaction['date']}</StyledTableCell>

                                                                                    <StyledTableCell align="right">{user_transaction['description']}</StyledTableCell>
                                                                                </StyledTableRow>
                                                                            )
                                                                        })}
                                                                    </TableBody>
                                                                    :
                                                                    <TableBody sx={{ borderBottom: 'none', borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px' }}>
                                                                        <TableRow sx={{ borderBottom: 'none', borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px' }}>
                                                                            <TableCell colSpan={3} sx={{ borderBottom: 'none', borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px' }}>
                                                                                <Box
                                                                                    sx={{
                                                                                        display: "flex",
                                                                                        flexDirection: "column",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",
                                                                                        padding: "40px 0",
                                                                                        textAlign: "center",
                                                                                    }}
                                                                                >
                                                                                    <div style={{ 
                                                                                        padding: '24px 16px', 
                                                                                        textAlign: 'center', 
                                                                                        borderRadius: '8px',
                                                                                    }}>
                                                                                        <div style={{ fontSize: '48px', marginBottom: '16px' }}>😔</div>
                                                                                        <h3 style={{
                                                                                            margin: '0',
                                                                                            fontSize: '20px',
                                                                                            fontWeight: '600',
                                                                                            color: '#1D1D1D',
                                                                                            fontFamily: 'Roboto, sans-serif',
                                                                                            marginBottom: '8px'
                                                                                        }}>No Income Yet</h3>
                                                                                        <p style={{
                                                                                            fontSize: '14px',
                                                                                            color: '#6E7787',
                                                                                            fontWeight: '400',
                                                                                            textAlign: 'center',
                                                                                            margin: '0 auto 24px',
                                                                                            maxWidth: '400px',
                                                                                            fontFamily: 'Roboto, sans-serif'
                                                                                        }}>
                                                                                            You'll start earning when you sell your first membership, course or product.
                                                                                        </p>
                                                                                        <div style={{
                                                                                            backgroundColor: '#F5F8FF',
                                                                                            padding: '16px',
                                                                                            margin: '0 auto 24px',
                                                                                            borderRadius: '8px',
                                                                                            display: 'flex',
                                                                                            flexDirection: 'column',
                                                                                            gap: '8px',
                                                                                            color: '#3B55F3',
                                                                                            border: '1px solid #E4EBF6',
                                                                                            maxWidth: '400px',
                                                                                        }}>
                                                                                            <div style={{
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                                justifyContent: 'center',
                                                                                                gap: '8px'
                                                                                            }}>
                                                                                                <AiOutlineSafety style={{ fontSize: '20px' }} />
                                                                                                <span style={{
                                                                                                    fontSize: '14px',
                                                                                                    fontWeight: '600'
                                                                                                }}>Focus on What You Love</span>
                                                                                            </div>
                                                                                            <p style={{
                                                                                                fontSize: '13px',
                                                                                                margin: '0',
                                                                                                fontWeight: '400',
                                                                                                lineHeight: '20px',
                                                                                                textAlign: 'center'
                                                                                            }}>
                                                                                                WithMe handles all refunds and chargebacks automatically. No need to worry about payment disputes – just focus on creating amazing content for your audience.
                                                                                            </p>
                                                                                        </div>
                                                                                        <p style={{
                                                                                            fontSize: '14px',
                                                                                            color: '#6E7787',
                                                                                            fontWeight: '400',
                                                                                            textAlign: 'center',
                                                                                            margin: '0',
                                                                                            fontFamily: 'Roboto, sans-serif'
                                                                                        }}>
                                                                                            Learn more about<a href={'https://help.withme.so/en/collections/8546931-growing-your-audience'} target="_blank" style={{ color: '#3B55F3', textDecoration: 'none' }}> how to get customers here.</a>
                                                                                        </p>
                                                                                    </div>

                                                                                </Box>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </TableBody>
                                                                }
                                                            </Table>
                                                        </TableContainer>
                                                        {this.state.influencer_transfers?.length > 0 && <TablePagination
                                                            style={{ backgroundColor: '#fff', borderBottomRightRadius: '8px', borderBottomLeftRadius: '8px' }}
                                                            component="div"
                                                            count={this.state.influencer_transfers.length}
                                                            page={this.state.page_num}
                                                            onPageChange={(_, page_num) => this.UpdatePageData(page_num)}
                                                            rowsPerPage={this.state.n_rows_per_page}
                                                            rowsPerPageOptions={window.innerWidth < 600 ? [5] : [5, 10, 25]}
                                                            onRowsPerPageChange={(e) => this.UpdateRowsPerPageData(e.target.value)}
                                                        />}
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: { xs: 'flex', 'md': 'none' },
                                                }}
                                            >
                                                <Grid
                                                    container
                                                    spacing={0}
                                                    alignItems="center"
                                                    justifyContent="center">
                                                    <Grid xs={12} sm={12} md={12} lg={12}>
                                                        {this.state.page_influencer_transfers.map((user_transaction, index) => {
                                                            return (
                                                                <Grid
                                                                    container
                                                                    item
                                                                    xs={12}
                                                                >
                                                                    <Accordion
                                                                        style={{
                                                                            backgroundColor: 'var(--rebranding-content-background-color)',
                                                                            color: '#9CA3B4',
                                                                            width: '100%',
                                                                        }}
                                                                    >
                                                                        <AccordionSummary
                                                                            expandIcon={<ExpandMoreIcon style={{ color: 'var(--light-theme-text-color)', fontSize: '30px', paddingRight: '20px' }} />}
                                                                            aria-controls="panel1a-content"
                                                                            id="panel1a-header"
                                                                            style={{ padding: '0px', margin: '0px', width: '100%' }}
                                                                        >
                                                                            <Typography
                                                                                style={{
                                                                                    fontSize: '16px',
                                                                                    fontWeight: '600',
                                                                                    paddingTop: '10px',
                                                                                    paddingLeft: '20px',
                                                                                    color: 'var(--light-theme-text-color)'
                                                                                }}
                                                                            >
                                                                                {user_transaction['date']}
                                                                            </Typography>
                                                                            <Typography
                                                                                style={{
                                                                                    float: 'right',
                                                                                    right: '80px',
                                                                                    position: 'absolute',
                                                                                    fontSize: '16px',
                                                                                    fontWeight: '600',
                                                                                    paddingTop: '10px',
                                                                                    color: 'var(--light-theme-text-color)'
                                                                                }}
                                                                            >
                                                                                {user_transaction['value']}
                                                                            </Typography>
                                                                        </AccordionSummary>
                                                                        <AccordionDetails>
                                                                            <Grid
                                                                                container
                                                                                xs={12}
                                                                            >
                                                                                <Grid
                                                                                    container
                                                                                    item
                                                                                    xs={12}
                                                                                >
                                                                                    <Typography
                                                                                        style={{
                                                                                            fontSize: '16px',
                                                                                            fontWeight: '600',
                                                                                            color: 'var(--light-theme-text-color)'
                                                                                            //    paddingTop: '10px',
                                                                                        }}
                                                                                    >
                                                                                        {user_transaction['description']}
                                                                                    </Typography>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </AccordionDetails>
                                                                    </Accordion>
                                                                </Grid>
                                                                // <StyledTableRow
                                                                //     key={'user_transaction_' + index}
                                                                //     // sx={{ '&:last-child td, &:last-child th': { border: 1 } }}
                                                                // >
                                                                //     <StyledTableCell component="th" scope="row">
                                                                //         {user_transaction['date']}
                                                                //     </StyledTableCell>
                                                                //     <StyledTableCell align="right">{user_transaction['price']}</StyledTableCell>
                                                                //     <StyledTableCell align="right">{user_transaction['influencer']}</StyledTableCell>
                                                                //     <StyledTableCell align="right">{user_transaction['description']}</StyledTableCell>
                                                                //     <StyledTableCell style={user_transaction_style} align="right">{user_transaction_status}</StyledTableCell>
                                                                //     <StyledTableCell align="right">
                                                                //         <a className={'invoice_text_link'} sx={{ position: 'absolute' }} href={user_transaction['invoice_url']} target="_blank" >
                                                                //             <HiDownload color={'#9CA3B4'} style={{ width: '20px', height: 'auto' }}/>
                                                                //         </a>
                                                                //     </StyledTableCell>
                                                                // </StyledTableRow>
                                                            )
                                                        })}
                                                        {this.state.influencer_transfers?.length > 0 && <TablePagination
                                                            component="div"
                                                            count={this.state.influencer_transfers.length}
                                                            page={this.state.page_num}
                                                            onPageChange={(_, page_num) => this.UpdatePageData(page_num)}
                                                            rowsPerPage={this.state.n_rows_per_page}
                                                            rowsPerPageOptions={window.innerWidth < 600 ? [5] : [5, 10, 25]}
                                                            onRowsPerPageChange={(e) => this.UpdateRowsPerPageData(e.target.value)}
                                                        />}
                                                    </Grid>
                                                </Grid>

                                            </Box>



                                        </Grid>
                                }




                            </Grid>









                            {/* <Grid
                        container
                    >
                        <Grid
                            container
                            xs={12} md={6}
                        >
                            <Typography
                                style={{
                                    color: '#222222',
                                    fontSize: '26px',
                                    fontWeight: '600',
                                    paddingBottom: '20px',
                                }}
                            >Payouts</Typography>
                        </Grid>
                        <Grid
                            container
                            item
                            xs={12}
                            sm={12}
                            md={6}
                            lg={6}
                            justifyContent="right"
                            alignItems="right"
                        >
                            <Box
                                sx={{ display: { xs: 'none', md: 'flex' } }}
                            >
                                <Button
                                    disableRipple
                                    variant="contained"
                                    sx={{
                                        backgroundColor: 'var(--brand-color)',
                                        fontSize: '14px',
                                        textTransform: 'none',
                                        marginBottom: '20px',
                                        boxShadow: 'none',
                                        fontWeight: '600',
                                        ':hover': {
                                            backgroundColor: 'var(--brand-color-hover)', // theme.palette.primary.main
                                            color: 'white', boxShadow: 'none',
                                        },
                                    }}
                                    type="submit" value="LOGIN"
                                    onClick={() => {
                                        setTimeout(() => {
                                            window.open(this.state.influencer_login_link)
                                        }, 800);
                                    }}>
                                    {button_text}
                                </Button>
                            </Box>

                        </Grid>
                        <Grid
                            container
                            item
                            xs={12}
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Typography
                                style={{
                                    color: 'var(--light-theme-text-color)',
                                    fontSize: '20px',
                                    fontWeight: '400',
                                    textAlign: 'center',
                                }}
                            >{testSetup ? 'Connect your account to enable instant payouts!' : 'Account connected. Instant payouts are active'}</Typography>
                        </Grid>
                        {testSetup ? null :
                            <><Grid
                                container
                                item
                                xs={12}
                                justifyContent="center"
                                alignItems="center"
                            >
                            </Grid>
                                <Typography
                                    style={{
                                        color: 'var(--light-theme-text-color)',
                                        fontSize: '12px',
                                        fontWeight: '300',
                                        paddingBottom: '0px',
                                        textAlign: 'center',
                                        width: '100%',
                                    }}
                                >Choose the frequency of your payouts (daily, weekly, monthly or manual).</Typography>
                                <Grid
                                    container
                                    item
                                    xs={12}
                                    sm={12}
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <Box
                                        sx={{ display: { xs: 'flex' }, marginTop: '20px' }}
                                    >

                                        <FormControl fullWidth height='16px'>

                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={this.state.payout_frequency}
                                                onChange={
                                                    (event) => {
                                                        this.setState(
                                                            {
                                                                process_loading: true,
                                                            }
                                                        )
                                                        const form_data = new FormData()
                                                        form_data.append('frequency', event.target.value)
                                                        axios({
                                                            method: 'post',
                                                            url: paths.BACKEND_URL + "api/settings/update_payout_frequency",
                                                            data: form_data,
                                                            headers: {
                                                                'Content-type': 'application/json',
                                                            },
                                                            withCredentials: true,
                                                        })
                                                            .then((res) => {
                                                                this.setState(
                                                                    {
                                                                        payout_frequency: event.target.value,
                                                                        next_date: res.data.next_date,
                                                                    }
                                                                )
                                                                this.setState(
                                                                    {
                                                                        process_loading: false,
                                                                    }
                                                                )
                                                            })
                                                    }
                                                }
                                                style={{ minWidth: '150px' }}
                                            >
                                                <MenuItem value={'Daily'} sx={{ textAlign: 'left' }}>
                                                    {'Daily'}
                                                </MenuItem>
                                                <MenuItem value={'Weekly'} sx={{ textAlign: 'left' }}>
                                                    {'Weekly'}
                                                </MenuItem>
                                                <MenuItem value={'Monthly'} sx={{ textAlign: 'left' }}>
                                                    {'Monthly'}
                                                </MenuItem>
                                                <MenuItem value={'Manual'} sx={{ textAlign: 'left' }}>
                                                    {'Manual'}
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid></>}
                        {this.state.payout_frequency !== 'Manual' && this.state.error !== 'account not completed' ? <Grid
                            container
                            item
                            xs={12}
                            sm={12}
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Box
                                sx={{ display: { xs: 'flex' }, marginTop: '20px' }}
                            >
                                <Typography>
                                    Your next payout will be: {this.state.next_date}
                                </Typography>
                            </Box>
                        </Grid> : null}
                        {this.state.payout_frequency === 'Manual' && this.state.error !== 'account not completed' ? 
                        <><Grid md={12} xs={12} container justifyContent={'center'} alignItems={'center'}>

                            <form style={{
                                backgroundColor: '#ffffff',
                                color: '#fff',
                                borderRadius: '5px',
                                padding: '0px 15px',
                                paddingRight: '0px',
                                display: 'flex',
                                height: '46px',
                                margin: '10px 0px 5px 0px',
                                border: '1px solid #C7D1DE',
                                width: '100%',
                                maxWidth: '200px',
                                zIndex: '10',
                                boxSizing: 'border-box'
                            }}>

                                <input type={"text"} id={"emailCaptureInput"} style={{
                                    border: 'none', width: 'calc(100% - 20px)', maxWidth: '200px', fontWeight: '500', color: '#1D1D1D', fontSize: '16px',
                                    fontFamily: 'Roboto'
                                }}
                                    placeholder='Payout amount'
                                    value={this.state.start_symbol + this.state.withdraw_amount_str + this.state.end_symbol}
                                    onChange={(event) => {
                                        // this.props.setUpdatedMonthlyInput(true)
                                        let processed_str = event.target.value.replace(/[^0-9.]/g, '')

                                        if (processed_str.includes('.')) {
                                            let splits = processed_str.split('.')
                                            let value = 0
                                            if (splits[0].length === 0) {
                                                value = 0
                                            } else {
                                                if (splits[1].length === 1) {
                                                    value = (Number(splits[0]) * 100) + (Number(splits[1]) * 10)
                                                } else if (splits[1].length === 0) {
                                                    value = (Number(splits[0]) * 100)
                                                } else {
                                                    value = (Number(splits[0]) * 100) + Number(splits[1])
                                                }
                                            }
                                            if (value < this.state.available_balance) {
                                                //    tPriceError('Must be a minimum of ' + this.props.currencySymbol+'2.99' + this.props.currencySymbolPost + '!');
                                                this.setState(
                                                    {
                                                        withdraw_amount_str: processed_str,
                                                        withdraw_amount: value,
                                                    }
                                                )
                                                // this.callMyFunction();
                                            } else {
                                                //    this.props.setMonthlyPriceError('');
                                                this.setState(
                                                    {
                                                        withdraw_amount_str: processed_str,
                                                        withdraw_amount: value,
                                                    }
                                                )
                                                // this.callMyFunction();
                                            }
                                        } else {
                                            if ((Number(processed_str) * 100) < 299) {
                                                this.props.setMonthlyPriceError('Must be a minimum of ' + this.props.currencySymbol + '2.99' + this.props.currencySymbolPost + '!');
                                                this.props.setMonthlyPriceStr(processed_str);
                                                this.props.setMonthlyPrice(Number(processed_str) * 100);
                                                // this.callMyFunction();
                                            } else {
                                                this.props.setMonthlyPriceError('');
                                                this.props.setMonthlyPriceStr(processed_str);
                                                this.props.setMonthlyPrice(Number(processed_str) * 100);
                                                // this.callMyFunction();
                                            }
                                        }
                                    }}
                                />

                            </form>

                        </Grid><Grid
                            container
                            item
                            xs={12}
                            sm={12}
                            justifyContent="center"
                            alignItems="center"
                        >
                                <Box
                                    sx={{ display: { xs: 'flex' }, marginTop: '20px' }}
                                >
                                    <Button
                                        disableRipple
                                        variant="contained"
                                        sx={{
                                            backgroundColor: 'var(--brand-color)',
                                            fontSize: '14px',
                                            textTransform: 'none',
                                            marginBottom: '20px',
                                            boxShadow: 'none',
                                            fontWeight: '600',
                                            ':hover': {
                                                backgroundColor: 'var(--brand-color-hover)', // theme.palette.primary.main
                                                color: 'white', boxShadow: 'none',
                                            },
                                        }}
                                        type="submit" value="LOGIN"
                                        onClick={() => {
                                            this.processPayout();
                                        }}>
                                        Payout
                                    </Button>
                                </Box>

                            </Grid>
                            <Grid
                                container
                                item
                                xs={12}
                                sm={12}
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Box
                                    sx={{ display: { xs: 'flex' }, marginTop: '0px' }}
                                >
                                    <Typography style={{ color: 'red' }}>
                                        {this.state.payout_error}
                                    </Typography>
                                </Box>
                            </Grid></> : null}
                        <Grid
                            container
                            item
                            xs={12}
                            sm={12}
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Box
                                sx={{ display: { xs: 'flex' }, marginTop: '20px' }}
                            >
                                <Typography>
                                    Available balance: {CreatePriceStr(this.state.available_balance, this.state.available_balance_currency, true)}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid
                            container
                            item
                            xs={12}
                            sm={12}
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Box
                                sx={{ display: { xs: 'flex' }, marginTop: '20px' }}
                            >
                                <Typography>
                                    Pending balance: {CreatePriceStr(this.state.pending_balance, this.state.pending_balance_currency, true)}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid
                            container
                            item
                            xs={12}
                            sm={12}
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Box
                                sx={{ display: { xs: 'flex', md: 'none' }, marginTop: '20px' }}
                            >
                                <Button
                                    disableRipple
                                    variant="contained"
                                    sx={{
                                        backgroundColor: 'var(--brand-color)',
                                        fontSize: '14px',
                                        textTransform: 'none',
                                        marginBottom: '20px',
                                        boxShadow: 'none',
                                        fontWeight: '600',
                                        ':hover': {
                                            backgroundColor: 'var(--brand-color-hover)', // theme.palette.primary.main
                                            color: 'white', boxShadow: 'none',
                                        },
                                    }}
                                    type="submit" value="LOGIN"
                                    onClick={() => {
                                        setTimeout(() => {
                                            window.open(this.state.influencer_login_link)
                                        }, 800);
                                    }}>
                                    {button_text}
                                </Button>
                            </Box>

                        </Grid>
                    </Grid> */}

                            {/* <FormGroup sx={{ margin: 'auto 0px auto auto' }}>
                                 <FormControlLabel control={
                                    <AntSwitch
                                       checked={this.state.oldAccount} onChange={
                                          (event) => {
                                             this.setState({oldAccount: event.target.checked})
                                          }}
                                    />}
                                    label={<span style={{
                                       fontSize: '13px',
                                       margin: '0px 5px 0px 0px',
                                       color: '#222222',
                                       fontWeight: '500',
                                       fontStyle: 'var(--main-font-family)',
                                    }}>{this.state.oldAccount ? "Old Account" : "New Account"}</span>}
                                    labelPlacement="start"
                                    style={{
                                       fontSize: 'px !important',
                                       marginRight: '5px',
                                       color: 'black',
                                       fontWeight: '600',
                                       fontStyle: 'var(--main-font-family)',
                                    }}
                                 />
                              </FormGroup> */}


                        </Grid>

                        <PayoutModal
                            payoutModal={this.state.payoutModal}
                            handlePayoutAmountUpdate={this.handlePayoutAmountUpdate}
                            withdraw_amount={this.state.withdraw_amount}
                            handlePayoutModalOpen={this.handlePayoutModalOpen}
                            handlePayoutModalClose={this.handlePayoutModalClose}
                            processPayout={this.processPayout}
                            // available_balance={this.state.available_balance}
                            availableBalance={CreatePriceStr(this.state.available_balance, this.state.available_balance_currency, true)}
                            start_symbol={this.state.start_symbol}

                        />
                        <SnackbarAlert
                            open={this.state.snackbarOpen}
                            msg={this.state.payout_error}
                            severity={this.state.snackbarSeverity}
                            autoHideDuration={4000}
                            handleClose={() => this.setState({ snackbarOpen: false })}
                            backgroundColor={this.state.snackbarColor}
                        />

                    </div>
                }
            </>

        )
    }
}

export default withRouter(Income);